import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Table, useDrawer } from "@digital-services/ui";
import { SortQueryDirection } from "@ds-cps/ui";

import { ResourceSummaryModel } from "@resource/models";

import { ResourceDetailsDrawer } from "../drawer/ResourceDetailsDrawer";
import { ResourcesTableDataRow } from "./ResourcesTableDataRow";
import { ResourcesTableHeaderRow } from "./ResourcesTableHeaderRow";

interface Props {
  resources: ResourceSummaryModel[];
  activeSort: string;
  sortDirection: SortQueryDirection | undefined;
  handleSort: (sortName: string) => void;
}

export const ResourcesOverviewTable: FC<Props> = props => {
  const { showDrawer } = useDrawer();

  const { resources, activeSort, sortDirection, handleSort } = props;

  const { t: tResource } = useTranslation(undefined, {
    keyPrefix: "resource"
  });

  function handleSortHeaderClick(columnName: string) {
    handleSort(columnName);
  }

  const openDrawer = (resource: ResourceSummaryModel) => {
    showDrawer({
      title: tResource("drawer.title", { serialNumber: resource.serialNumber }),
      children: <ResourceDetailsDrawer resourceSummary={resource} />
    });
  };

  return (
    <Table className="w-full" rowHoverHighlight>
      <thead className="[&>tr>th]:sticky [&>tr>th]:top-0 [&>tr>th]:bg-white">
        <ResourcesTableHeaderRow
          handleSortHeaderClick={handleSortHeaderClick}
          activeSort={activeSort}
          sortDirection={sortDirection}
        />
      </thead>
      <tbody data-testid="tbody">
        {resources.map((resource: ResourceSummaryModel) => (
          <ResourcesTableDataRow
            key={`key-${resource.id}-${resource.serialNumber}`}
            data={resource}
            onRowClick={() => openDrawer(resource)}
          />
        ))}
      </tbody>
    </Table>
  );
};
